import instance from '../utils/axios';

export const fetchAllEvents = async () => {
    const response = await instance.get('/api/event/all');
    return response.data;
};
export const fetchAllEventsBeforeLogin = async () => {
    const response = await instance.get('/api/event/events-without-login');
    return response.data;
};

export const fetchEventDetailsById = async (eventId) => {
    const response = await instance.get(`/api/event/${eventId}`);
    return response.data;
};

export const fetchEventDetailsByIdBeforLogin = async (eventId) => {
    const response = await instance.get(`/api/event/event-detail-without-login/${eventId}`);
    return response.data;
};

export const fetchFancyData = async (eventId) => {
    const response = await instance.get(`/api/event/event-fancy-without-login/${eventId}`)
    return response.data
}
export const fetchAllEventTypes = async () => {
    const response = await instance.get('/api/event/all-event-types');
    return response.data;
}

export const fetchOpenBetEvents = async (event_type) => {
    const response = await instance.get(`/api/event/open-bet-events/${event_type}`);
    return response.data;
}